<template>
  <div class="flex objection-section" :style="style">
    <div class="objection-left" :style="leftStyle">
      <slot name="left"></slot>
    </div>
    <div class="objection-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    height: {
      type: [String, Number],
      default: '100%'
    },

    leftWidth: {
      type: [String, Number],
      default: '30%'
    }
  },

  computed: {
    style() {
      return `height: ${this.height || '100%'};`
    },

    leftStyle() {
      return `width: ${this.leftWidth || '30%'};`
    }
  }
}
</script>
<style lang="scss" scoped>
.objection-section {
  height: 100%;
  border-top: 1px solid $info-fourth-color;

  .objection-left {
    min-width: 25%;
    max-width: 30%;
    height: 100%;
    border-right: 1px solid $info-fourth-color;
  }

  .objection-right {
    flex: 1;
    height: 100%;
  }
}
</style>